import React, {useState, useEffect} from "react";
import Tabs from "../../../../app/components/Tabs";
import General from "./tabsOrganizations/General";
import Statics from "./tabsOrganizations/Statics";
import Financial from "./tabsOrganizations/Financial";
import Audit from "./tabsOrganizations/Audit";
import { usePageTitle } from '../../../../contexts/PageTitleContext';



const AdministrativePanel = () => {
    const { setTitle } = usePageTitle();
      
      useEffect(() => {
        setTitle('Painel Administrativo');
      }, [setTitle]); 
    
    const [activeTab, setActiveTab] = useState('geral');

    const TabsOrganization = [
        {id: 'geral',name: 'Geral'},
        {id: 'estatistica',name: 'Estatísticas de Uso'},
        {id: 'financeiro',name: 'Financeiro'},
        {id: 'auditoria',name: 'Log de Auditoria'}
    ]

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    return(
        <div>
            <Tabs
                tabs={TabsOrganization}
                activeTabName={activeTab}
                onTabClick={handleTabClick}
            />
            <div className="mt-4">
                {activeTab === 'geral' && <General />}
                {activeTab === 'estatistica' && <Statics />}
                {activeTab === 'financeiro' && <Financial />}
                {activeTab === 'auditoria' && <Audit />}
            </div>
        </div>
    )
}

export default AdministrativePanel